import { useNavigation } from "@/providers";
import { CreateEntityButton } from "@/shared/components/CreateEntityButton";

import { AgentThreadsTable } from "./AgentThreadsTable";

export function ThreadsTab() {
  const { goto } = useNavigation();

  return (
    <AgentThreadsTable
      trailingActions={
        <CreateEntityButton
          entity="thread"
          onClick={() => goto.newAgentThread()}
        />
      }
      noData={{
        action: (
          <CreateEntityButton
            entity="thread"
            variant="secondary"
            onClick={() => goto.newAgentThread()}
          />
        ),
      }}
    />
  );
}
